import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/** `share` (PD-17455): a one-time send from a report's Share menu. */
export type ReportScheduleRunTriggerModel = 'scheduled' | 'now' | 'preview' | 'share';
export type ReportScheduleRunStatusModel = 'running' | 'sent' | 'partial' | 'failed' | 'skipped';

/**
 * PD-17398 — one send of a scheduled report: on schedule, Send now, or Send
 * me a preview. Its deliveries record each recipient.
 */
@Index('idx_report_schedule_run_schedule', ['fkReportScheduleId', 'startedAt'])
// auditable: false - send bookkeeping written by the delivery job; the schedule itself is audited.
@Entity('report_schedule_run', {}, { auditable: false })
export class ReportScheduleRunEntity extends BaseEntity {
	@Column('int', { name: 'fk_report_schedule__id', unsigned: true })
	public fkReportScheduleId!: number;

	@Column('varchar', { name: 'trigger', length: 20 })
	public trigger!: ReportScheduleRunTriggerModel;

	/** The due time this run answers (the claimed nextRunAt), or when it was started by hand. */
	@Column('datetime', { name: 'scheduledFor' })
	public scheduledFor!: Date;

	@Column('datetime', { name: 'startedAt' })
	public startedAt!: Date;

	@Column('datetime', { name: 'finishedAt', nullable: true })
	public finishedAt!: Date | null;

	@Column('varchar', { name: 'status', length: 20, default: 'running' })
	public status!: ReportScheduleRunStatusModel;

	@Column('int', { name: 'recipientCount', default: 0 })
	public recipientCount!: number;

	@Column('int', { name: 'deliveredCount', default: 0 })
	public deliveredCount!: number;

	/** Why it was skipped or failed, in words. */
	@Column('varchar', { name: 'note', length: 500, nullable: true })
	public note!: string | null;

	/** Tenant `user._id` who pressed Send now or asked for the preview. */
	@Column('int', { name: 'fk_user__id_requested', unsigned: true, nullable: true })
	public fkUserIdRequested!: number | null;
}
